export default "/fonts/vendor/katex/dist/KaTeX_Size1-Regular.ttf?6de7d4b539221a49e9e241b734653ecf";